import { render, staticRenderFns } from "./visNoticeDetail.vue?vue&type=template&id=020f437c&scoped=true&"
import script from "./visNoticeDetail.vue?vue&type=script&lang=js&"
export * from "./visNoticeDetail.vue?vue&type=script&lang=js&"
import style0 from "./visNoticeDetail.vue?vue&type=style&index=0&id=020f437c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f437c",
  null
  
)

export default component.exports